import { api } from '@/shared/redux/api/_generated/api/notifications-api.generated';

export const notificationsApi = api.enhanceEndpoints({
  addTagTypes: [
    'Notification',
    'NotificationPreference',
    'Webhook',
    'Tenant',
    'Secret',
    'Gateway',
  ],
  endpoints: {
    ReadAllNotifications: {
      providesTags: [{ type: 'Notification', id: 'LIST' }],
    },
    UnreadNotificationsCount: {
      providesTags: [{ type: 'Notification', id: 'UNREAD_COUNT' }],
    },
    ReadAllWebhookConfigurations: {
      providesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    CreateWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    UpdateWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    DeleteWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    UpdateNotificationReadStatus: {
      invalidatesTags: [
        { type: 'Notification', id: 'LIST' },
        { type: 'Notification', id: 'UNREAD_COUNT' },
      ],
    },
    ReadMyNotificationPreference: {
      providesTags: [{ type: 'NotificationPreference', id: 'MINE' }],
    },
    UpdateMyNotificationPreference: {
      invalidatesTags: [{ type: 'NotificationPreference', id: 'MINE' }],
    },
    // Setting or removing a row refreshes the page.
    ReadMyFollowedItems: {
      providesTags: [{ type: 'NotificationPreference', id: 'ENTITY_LIST' }],
    },
    ReadMyEntityNotificationPreference: {
      providesTags: (_, __, args) => [
        {
          type: 'NotificationPreference',
          id: `${args.entityType}:${args.entityId}`,
        },
      ],
    },
    SetMyEntityNotificationPreference: {
      invalidatesTags: (_, __, args) => [
        { type: 'NotificationPreference', id: 'ENTITY_LIST' },
        {
          type: 'NotificationPreference',
          id: `${args.entityType}:${args.entityId}`,
        },
      ],
    },
    RemoveMyEntityNotificationPreference: {
      invalidatesTags: (_, __, args) => [
        { type: 'NotificationPreference', id: 'ENTITY_LIST' },
        {
          type: 'NotificationPreference',
          id: `${args.entityType}:${args.entityId}`,
        },
      ],
    },
  },
});

export const {
  useReadAllNotificationsQuery,
  useReadAllWebhookConfigurationsQuery,
  useLazyReadAllWebhookConfigurationsQuery,
  useReadWebhookEventsQuery,
  useCreateWebhookConfigurationMutation,
  useUpdateWebhookConfigurationMutation,
  useDeleteWebhookConfigurationMutation,
  useLazyReadAllowedWebhookModelKeysQuery,
  useUpdateNotificationReadStatusMutation,
  useUnreadNotificationsCountQuery,
  useReadNotificationCatalogueQuery,
  useReadMyNotificationPreferenceQuery,
  useUpdateMyNotificationPreferenceMutation,
  useReadMyEntityNotificationPreferenceQuery,
  useSetMyEntityNotificationPreferenceMutation,
  useRemoveMyEntityNotificationPreferenceMutation,
  useReadEntityFollowersQuery,
  useReadMyAddedFollowQuery,
  useReadMyFollowedItemsQuery,
} = notificationsApi;
